import { InView } from 'react-intersection-observer'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import type { DeliveryTypes } from '../FreightSimulation'
import { FreightDetailsPrice } from './FreightDetailsPrice'
import { sendShippingEvent } from '../utils/sendShippingEvent'
import { formatDeliveryTypeName } from '../utils/formatDeliveryTypeName'

const EVENT_NAMES = {
  fast: 'fast delivery',
  economic: 'economic delivery',
}

export const FreightDetailsBox = ({
  deliveryData,
}: {
  deliveryData: DeliveryTypes[0] | null
}) => {
  const { pageData } = useGlobalContext()

  if (!deliveryData) {
    return null
  }

  return (
    <InView
      as="div"
      triggerOnce
      onChange={(inView) => {
        if (inView) {
          const eventName =
            EVENT_NAMES[deliveryData?.type as keyof typeof EVENT_NAMES]

          sendShippingEvent({ eventName, pageData })
        }
      }}
      className="flex items-start justify-between"
    >
      <div className="flex flex-col gap-[2px]">
        <span className="text-black text-sm leading-[21px] font-semibold">
          {formatDeliveryTypeName(deliveryData.type)}
        </span>
        <span className="text-restructure-primary text-sm leading-[21px] font-regular">
          Receba em até {deliveryData.shippingEstimate}
        </span>
      </div>
      <FreightDetailsPrice deliveryValue={deliveryData.value} />
    </InView>
  )
}
